import { MessagesSquare } from 'lucide-react';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface ContactButtonProps {
	onClick: () => void;
	className?: string;
}

function ContactButton({ onClick, className }: ContactButtonProps): React.JSX.Element {
	const { t } = useTranslation();

	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			onClick={onClick}
			iconRight={<MessagesSquare className="!w-3.5 !h-3.5" />}
			className={className}
			data-testid="header-button-direct-contact"
			aria-label={t('header.contact')}
		>
			{/* Label hidden below sm — the header row is tight on phones, so the
			    action buttons collapse to their icons there. */}
			<span className="hidden sm:inline">{t('header.contact')}</span>
		</Button>
	);
}

export default ContactButton;
